const data = [
  {
    title: "What is ALPHA OCTOPUS ?",
    text: "The ALPHA OCTOPUS is a collection of 888 unique digital collectibles living on the Ethereum blockchain.",
  },
  {
    title: "What are the perks for whitelisting ?",
    text: "You will get early acces to ALPHA OCTOPUS in a private sale which has 15% discount on actual minting fee, and you will be able to participate in the community and get rewards.",
  },
  {
    title: "Why we should choose ALPHA OCTOPUS ?",
    text: "Your ALPHA OCTOPUS will double up as a membership to the exclusive ALPHA OCTOPUS club where owners will be rewarded with perks and benefits, not to mention the charitable causes associated with this project and its Amazing roadmap.",
  },
  {
    title: "How to Mint ALPHA OCTOPUS without paying a gas fee ?",
    text: "You can whitelist yourself by just joining our discord, and get an early access to ALPHA OCTOPUS.",
  },
  {
    title: " How many ALPHA OCTOPUS I can Mint ?",
    text: "You can mint three(3) ALPHA OCTOPUS NFT per wallet address for private sale and five(5) ALPHA OCTOPUS NFT per wallet address for public sale. so the maximum you can mint is total 8 ALPHA OCTOPUS NFT per wallet address.",
  },
  {
    title: "Why should I hold an ALPHA OCTOPUS",
    text: "Alpha Octopus is not just an NFT art, It has many luxurious Utilities and Benefits that will be available to you when you hold an Alpha Octopus.",

  },
  {
    title: "What are the utilities for Holding ALPHA OCTOPUS ?",
    text: "The utilities of holding Alpha Octopus includes life style coach management, success wealth management coaching, concierge service, shareholder collective utility implementation, and online merchandise store.",

  }
];

export default data;
